import React from 'react';

interface MetaDataTableProps {
  metaData: string | null;
}

export const MetaDataTable: React.FC<MetaDataTableProps> = ({ metaData }) => {
  if (!metaData) return null;

  let parsedData: Record<string, any>;
  try {
    parsedData = JSON.parse(metaData);
  } catch {
    return (
      <div className="p-3 bg-default-100 dark:bg-default-50 rounded-lg">
        <p className="text-sm text-default-600">{metaData}</p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-default-100 rounded-lg shadow-lg border border-default-200 max-h-96 overflow-auto">
      <table className="w-full text-sm">
        <thead className="bg-default-100 dark:bg-default-50 sticky top-0">
          <tr>
            <th className="text-left p-3 font-semibold text-foreground border-b border-default-200">
              Key
            </th>
            <th className="text-left p-3 font-semibold text-foreground border-b border-default-200">
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(parsedData).map(([key, value]) => (
            <tr
              key={key}
              className="border-b border-default-200 last:border-b-0 hover:bg-default-50"
            >
              <td className="p-3 font-medium text-foreground">{key}</td>
              <td className="p-3 text-default-600 break-all">
                {typeof value === 'object' && value !== null
                  ? JSON.stringify(value, null, 2)
                  : String(value)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
